import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { fetchGlobalFiguresOrThrow } from '../../../../api/model/output/global-figures';
import { getVersionAndReleaseIfExists } from '../../../../untidy/redux/selectors';

export function useLoadGlobalFigures() {
  const { version } = useSelector(getVersionAndReleaseIfExists);
  const { data } = useQuery({
    queryKey: ['fetchGlobalFigures', version],
    queryFn: async () => await fetchGlobalFiguresOrThrow(version!),
    enabled: !!version,
  });
  return data;
}
